// Optional features for the open company (olfin/features.py) — pages read them with useFeatures().
import { createContext, useContext } from 'react';

export const FeaturesContext = createContext({});
export const useFeatures = () => useContext(FeaturesContext);
